// dependencies
import { useQuery } from "@tanstack/react-query";

// api
import { fetchNotificationChannelsSettings, fetchTemplateNotificationChannelsSettings } from "../../services";

// FETCH NOTIFICATION CHANNEL SETTINGS

export const useNotificationChannelSettings = (isTemplate: boolean) => {
	if (isTemplate) {
		return useFetchTemplateNotificationChannelSettings();
	}
	return useFetchNotificationChannelSettings();
};

const useFetchNotificationChannelSettings = () => {
	return useQuery({
		queryKey: ["fetchNotificationChannelSettings"],
		queryFn: () => fetchNotificationChannelsSettings(),
		meta: {
			errorMessage: "There was an error getting the notification channel settings.",
		},
	});
};

const useFetchTemplateNotificationChannelSettings = () => {
	return useQuery({
		queryKey: ["fetchNotificationrTemplateChannelSettings"],
		queryFn: () => fetchTemplateNotificationChannelsSettings(),
		meta: {
			errorMessage: "There was an error getting the notification channel settings.",
		},
	});
};
